import { ErrorsInterface } from "../../../types/src/lib/types/error";

const NO_MATCH =
  "Oops, it looks like your email and password combination don't match!";

export const SignUpErrorMessages: ErrorsInterface = {
  not_found: NO_MATCH,
  invalid_password: NO_MATCH,
  account_locked: "Your account has been locked.",
  unverified_email: "Please enter a valid email address.",
};
